import { useMemo } from 'react';

import { type Column } from 'components/DataGrid';
import type { GridSummaryRow, RowOrGroup } from '../../types';
import { createMonthColums } from '../delivery';
import { useAtomValue } from 'jotai';

import { createTitleColumn } from '../columns/TitleColumn';
import { selectionEnabledAtom, maxDepthAtom, usePlanStrategy, usePlanSettings } from '../../state';
import { SelectColumn } from '../columns/SelectColumn';
import type { Calendar } from '../calendar/types';

export function useColumns(calendar: Calendar): Column<RowOrGroup, GridSummaryRow>[] {
  const settings = usePlanSettings();
  const strategy = usePlanStrategy();
  const enableSelection = useAtomValue(selectionEnabledAtom);
  const maxDepth = useAtomValue(maxDepthAtom);

  return useMemo(
    () => [
      ...(enableSelection ? [SelectColumn] : []),
      createTitleColumn(maxDepth),
      ...strategy.getColumns(settings, calendar),
      ...createMonthColums(calendar.interval),
    ],
    [strategy, settings, enableSelection, maxDepth, calendar],
  );
}
